webpackJsonp([168916099247572],{

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _videoReact = __webpack_require__(21);
	
	var _attnLogo = __webpack_require__(31);
	
	var _attnLogo2 = _interopRequireDefault(_attnLogo);
	
	var _carousel = __webpack_require__(63);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _footerNew = __webpack_require__(15);
	
	var _footerNew2 = _interopRequireDefault(_footerNew);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var media = [{
	  id: 'first',
	  type: 'video',
	  image: '/img/rollupyoursleeves/carousel01.png',
	  video: '/video/rollupyoursleeves/carousel01.mp4'
	}, {
	  id: 'second',
	  type: 'video',
	  image: '/img/rollupyoursleeves/carousel02.png',
	  video: '/video/rollupyoursleeves/carousel02.mp4'
	}];
	
	var sizzleMedia = {
	  image: '/img/rollupyoursleeves/NBC_RollUpYourSleeve_Promos_Announcement-still.png',
	  video: '/video/rollupyoursleeves/NBC_RollUpYourSleeve_Promos_Announcement.mp4'
	};
	
	var VaccineSpecialPage = function (_Component) {
	  _inherits(VaccineSpecialPage, _Component);
	
	  function VaccineSpecialPage(props) {
	    _classCallCheck(this, VaccineSpecialPage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      isMobile: false,
	      playing: false
	    };
	
	    _this.playShowVideo = _this.playShowVideo.bind(_this);
	    _this.stopShowVideo = _this.stopShowVideo.bind(_this);
	    _this.handleShowPlayerState = _this.handleShowPlayerState.bind(_this);
	    return _this;
	  }
	
	  VaccineSpecialPage.prototype.componentDidMount = function componentDidMount() {
	    var isMobile = window.innerWidth < 1024;
	
	    this.setState({
	      isMobile: isMobile
	    });
	
	    if (this.refs.showPlayer) {
	      this.refs.showPlayer.subscribeToStateChange(this.handleShowPlayerState);
	    }
	  };
	
	  VaccineSpecialPage.prototype.handleShowPlayerState = function handleShowPlayerState(_ref) {
	    var ended = _ref.ended;
	
	    if (ended) {
	      this.stopShowVideo();
	    }
	  };
	
	  VaccineSpecialPage.prototype.playShowVideo = function playShowVideo() {
	    var _refs = this.refs,
	        showVideo = _refs.showVideo,
	        showPlayer = _refs.showPlayer;
	
	
	    showVideo.scrollIntoView();
	    this.setState({
	      playing: true
	    }, function () {
	      showPlayer.play();
	    });
	  };
	
	  VaccineSpecialPage.prototype.stopShowVideo = function stopShowVideo() {
	    var showPlayer = this.refs.showPlayer;
	
	    showPlayer.pause();
	    showPlayer.load();
	
	    this.setState({
	      playing: false
	    });
	  };
	
	  VaccineSpecialPage.prototype.render = function render() {
	    var playing = this.state.playing;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'show vaccine-special' },
	      _react2.default.createElement(
	        'header',
	        { className: 'show-header' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          _react2.default.createElement(_attnLogo2.default, { classes: 'logo', theme: 'dark' })
	        ),
	        _react2.default.createElement('a', {
	          className: 'client-logo',
	          href: '',
	          target: '_blank',
	          rel: 'noreferrer noopener'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'show-body' },
	        _react2.default.createElement('img', { className: 'show-body__image', src: '/img/rollupyoursleeves/logo_wall.jpg' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'show-body__video one-by-one', ref: 'showVideo' },
	          _react2.default.createElement(
	            _videoReact.Player,
	            {
	              className: 'video',
	              ref: 'showPlayer',
	              aspectRatio: '16:9',
	              autoPlay: false,
	              loop: false,
	              muted: false,
	              playsInline: true,
	              poster: sizzleMedia.image,
	              preload: 'none',
	              src: sizzleMedia.video
	            },
	            _react2.default.createElement(_videoReact.BigPlayButton, { disabled: true }),
	            _react2.default.createElement(_videoReact.ControlBar, { disabled: !playing }),
	            _react2.default.createElement(_videoReact.Shortcut, { disabled: !playing })
	          ),
	          playing ? _react2.default.createElement('div', { className: 'stop-button', onClick: this.stopShowVideo }) : _react2.default.createElement('div', { className: 'play-button', onClick: this.playShowVideo })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'show-body__cta-button' },
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://madetosave.org',
	              target: '_blank',
	              rel: 'noreferrer noopener',
	              className: 'btn btn--primary-outline btn--icon-right'
	            },
	            'Made to save',
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('i', { className: 'fas fa-long-arrow-alt-right' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'show-body__post' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Tune in on Sunday, April 18 at 7 p.m. ET/PT on NBC for Roll Up Your Sleeves Presented by Walgreens. This special night of entertainment event will educate viewers, raise awareness, and dispel concerns surrounding the COVID-19 vaccines, all with the goal of encouraging vaccinations to finally put an end to the pandemic.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Hosted by Russell Wilson and Ciara, Roll Up Your Sleeves Presented by Walgreens will feature the biggest names in entertainment, including comedy from Billy Crystal and Wanda Sykes, appearances by Sterling K. Brown, Lana Condor, Eric Dane, Ryan Eggold, Jennifer Hudson, Dale Jarrett, Dr. Ken Jeong, Joe Jonas, Eva Longoria, Demi Lovato, Joel McHale, Kumail Nanjiani, Ellen Pompeo, Jane Seymour and many more! Plus, tune in to celebrate frontline heroes and witness heartwarming reunions of everyday people.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Starting April 19, COVID-19 vaccines will be available to all American adults, to make a plan to ROLL UP YOUR SLEEVES!'
	          )
	        ),
	        media && media.length > 0 ? _react2.default.createElement(_carousel2.default, { media: media, interval: 15000 }) : null
	      ),
	      _react2.default.createElement(_footerNew2.default, { theme: 'dark' })
	    );
	  };
	
	  return VaccineSpecialPage;
	}(_react.Component);
	
	exports.default = VaccineSpecialPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-rollupyoursleeves-js-3ccf0a469083d9c809fa.js